import { useDispatch, useSelector } from "react-redux";

import { colorSelected, filterStatus } from "../features/filter/filterSlice";

export default function Footer() {
  const { colors, count } = useSelector((state) => state.filter);
  const state = useSelector((state) => state);
  console.log(state);
  const dispatch = useDispatch();
  const selectColor = (color) => {
    dispatch(colorSelected(color));
  };
  const handleStatus = (status) => {
    dispatch(filterStatus(status));
  };

  return (
    <div class="mt-4 flex justify-between text-xs text-gray-500">
      <p>{count} tasks left</p>
      <ul class="flex space-x-1 items-center text-xs">
        <li
          class="cursor-pointer font-bold"
          onClick={() => handleStatus("all")}
        >
          All
        </li>
        <li>|</li>
        <li class="cursor-pointer" onClick={() => handleStatus("incomplete")}>
          Incomplete
        </li>
        <li>|</li>
        <li class="cursor-pointer" onClick={() => handleStatus("complete")}>
          Complete
        </li>
        <li></li>
        <li></li>
        <li
          onClick={() => selectColor("green")}
          class={`h-3 w-3 border-2 border-green-500 md:hover:bg-green-500 rounded-full cursor-pointer ${
            colors.includes("green") && "bg-green-500"
          } `}
        ></li>
        <li
          onClick={() => selectColor("red")}
          class={`h-3 w-3 border-2 border-red-500 md:hover:bg-red-500 rounded-full cursor-pointer ${
            colors.includes("red") && "bg-red-500"
          }`}
        ></li>
        <li
          onClick={() => selectColor("yellow")}
          class={`h-3 w-3 border-2 border-yellow-500 md:hover:bg-yellow-500 rounded-full cursor-pointer ${
            colors.includes("yellow") && "bg-yellow-500"
          }`}
        ></li>
      </ul>
    </div>
  );
}
